export const MEDIA_TYPE = {
  RECEIPT: 'RECEIPT',
  BILL: 'BILL'
}
